<div class="main-container">
  <div>
    <div class="card-header" id="headingOne" *ngIf="sTitlePrimary != undefined" >
      <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
        aria-controls="collapseOne">
        1. {{sTitlePrimary}}
        <i class="fa fa-chevron-down"></i>
      </button>
    </div>
    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
      <div class="card-body">
        <ng-content select="[content-1]"></ng-content>
      </div>
    </div>
  </div>
  <div>
    <div class="card-header" id="headingTwo" *ngIf="sTitleSecond != undefined">
      <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
        aria-controls="collapseTwo">
        2. {{sTitleSecond}}
        <i class="fa fa-chevron-down"></i>
      </button>
    </div>
    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
      <div class="card-body">
        <ng-content select="[content-2]"></ng-content>
      </div>
    </div>
  </div>
  <div>
    <div class="card-header" id="headingTree" *ngIf="sTitleThird != undefined">
      <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTree" aria-expanded="false"
        aria-controls="collapseTree">
        3. {{sTitleThird}}
        <i class="fa fa-chevron-down"></i>
      </button>
    </div>
    <div id="collapseTree" class="collapse" aria-labelledby="headingTree" data-parent="#accordion">
      <div class="card-body">
        <ng-content select="[content-3]"></ng-content>
      </div>
    </div>
  </div>
</div>